import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { createKey } from 'src/utils/CaseDetail.utils';
import { RootState } from 'src/store';
import AddNewNumberOverlay from '../MoreDetails/AddNewNumberOverlay';
import { getCustomerConfidence, getTelephonesV2 } from '../../actions/casesDetailsActions';
import CustomerDeviceData from './CustomerDeviceData';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';
import styles from './index.module.scss';
import cx from 'classnames';

function PhoneNumberDetails() {
  const {
    loanId = '',
    customerId = '',
    caseBusinessVertical = '',
    caseReferenceId = ''
  } = useParams();
  const dispatch = useDispatch();
  const telephones = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.telephonesv2?.data
  );
  useEffect(() => {
    if (!telephones)
      dispatch(getTelephonesV2(loanId, customerId, caseReferenceId, caseBusinessVertical));
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_Phone_PageLand);
  }, [loanId, customerId]);

  return (
    <div className={cx(styles.tabContentScroll)}>
      <div className={styles.header}>
        <AddNewNumberOverlay />
      </div>
      <div className={styles.phoneNumberWrapper}>
        {telephones?.length ? (
          <CustomerDeviceData data={telephones} loading={false} error={false} />
        ) : null}
      </div>
    </div>
  );
}

export default PhoneNumberDetails;
